import { render, staticRenderFns } from "./BillMchInfo.vue?vue&type=template&id=2d32ff08"
import script from "./BillMchInfo.vue?vue&type=script&lang=js"
export * from "./BillMchInfo.vue?vue&type=script&lang=js"
import style0 from "./BillMchInfo.vue?vue&type=style&index=0&id=2d32ff08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports